module.exports = __webpack_public_path__ + "img/logo_sram_noir.470bd66.svg";